/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Epic } from 'redux-observable';
import { Properties } from '@api/model';
import { GET_SYSTEM_PROPERTIES, getSystemPropertiesFulfilled } from '../../actions/SystemProperties';
import { Request, Create } from '../EpicUtils';
import GoogleService from '../../../api/services/GoogleService';

const request: Request<Properties, null> = {
  type: GET_SYSTEM_PROPERTIES,
  getData: () => GoogleService.getProperties(),
  processData: (res) => [getSystemPropertiesFulfilled(res)]
};

export const EpicGetSystemProperties: Epic<any, any> = Create(request);